export default __webpack_public_path__ + "static/media/pet_1.40d3f220.png";